import React from 'react';
import styled from 'styled-components';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";
import { device, textLimiter } from 'vqp-common';

import useFetch from '../../utils/useFetch'
import { fetchReviews } from '../../redux/actions/dashboard'

import { RatingScoreCard , RatingsList } from './'

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;
    
    @media ${device.desktop} {
        grid-template-columns: 1fr 3fr;
    }
`


export const ReviewsPanel = ({filterDates}) => {

    const reviews = useFetch(fetchReviews, filterDates)

        if (reviews.loading) 
            return (
                <Grid>
                    <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                    <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
                </Grid>
            )
        else if (reviews.response) {
            const ratings = reviews.response.comments.map(rating => {
                return {
                    ...rating,
                    text: textLimiter(rating.text, 55, true)
                }
            })
            return (
                <Grid>
                    <RatingScoreCard score={reviews.response.score} totalRatings={reviews.response.comments.length} />
                    <RatingsList ratings={ratings.slice(1,30)} />
                </Grid>
            )
        }
        return null

}